import {
    FILTER_WASTE_REQUEST,
    FILTER_WASTE_SUCCESS,
    FILTER_WASTE_FALUIRE,
} from './filterWasteType'

const initialState = {
    loadingFilter: false,
    filterWaste: null,
    error: '',
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FILTER_WASTE_REQUEST: return {
            ...state,
            loadingFilter: true,
        }

        case FILTER_WASTE_SUCCESS: return {
            ...state,
            filterWaste: action.payload,
            error: '',
            loadingFilter: false,
        }

        case FILTER_WASTE_FALUIRE: return {
            ...state,
            loadingFilter: false,
            filterWaste: null,
            error: action.payload,
        }
        default: return state
    }
}

export default reducer
